// extracted by mini-css-extract-plugin
module.exports = {"card_container":"Card_card_container__2CyuY","card":"Card_card__1AxkD"};